var React = require('react');

function TruckMoving (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224 352a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm-160 0a64 64 0 1 0 64 64 64 64 0 0 0-64-64zm464 0a64 64 0 1 0 64 64 64 64 0 0 0-64-64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M621.3 237.3l-58.5-58.5a64 64 0 0 0-45.3-18.7H480V64a32 32 0 0 0-32-32H32A32 32 0 0 0 0 64v280.51A95.88 95.88 0 0 1 144 363a96 96 0 0 1 170.51 21h123a96 96 0 0 1 181 0H624a16 16 0 0 0 16-16v-85.5a63.79 63.79 0 0 0-18.7-45.2zM480 256v-48h37.5a15.88 15.88 0 0 1 11.3 4.7l43.3 43.3z","className":"fa-primary","key":2})]);
}

TruckMoving.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = TruckMoving;

TruckMoving.default = TruckMoving;
